module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 258
// module chunks = 0